<div>
  <h1>
    Requests
  </h1>
</div>

<app-requests-list [zombieId]="zombieId" [dateStart]="dateStart" [dateEnd]="dateEnd" [limit]="limit"></app-requests-list>
